var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1047",
    "data-name": "Ellipse 1047",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#ffe2cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908",
    transform: "translate(2968 -2057.729)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_995",
    "data-name": "Ellipse 995",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(-2968 2057.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    transform: "translate(-2968 2057.729)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    transform: "translate(11.153 5.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15998",
    "data-name": "Path 15998",
    d: "M69.684,59.5V57.7a5.124,5.124,0,1,0-10.248,0v1.79Z",
    transform: "translate(-43.073 -52.573)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15999",
    "data-name": "Path 15999",
    d: "M72.573,86.474l-3.349,48.969H57.186l-.417-49.648Z",
    transform: "translate(-43.677 -45.052)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16000",
    "data-name": "Path 16000",
    d: "M62.117,133.378l1.312-38.6",
    transform: "translate(-42.466 -43.018)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16001",
    "data-name": "Path 16001",
    d: "M62.809,91.789h.247a1.35,1.35,0,0,0,1.358-1.358V87.947h-1.6Z",
    transform: "translate(-42.309 -44.565)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16002",
    "data-name": "Path 16002",
    d: "M55.774,90.482a2.855,2.855,0,0,0,2.871,2.824H71.562a2.756,2.756,0,0,0,1.42-.386,2.791,2.791,0,0,0,1.374-2.176l-.2-22.177a15.909,15.909,0,0,0-6.266-3.472H63.135c-.972,0-7.1,2.407-8.72,4.8Z",
    transform: "translate(-44.21 -49.739)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16003",
    "data-name": "Path 16003",
    d: "M68.8,77.276l2.284,9.337-.046-7.331Z",
    transform: "translate(-40.953 -46.981)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16004",
    "data-name": "Path 16004",
    d: "M63.35,66.328V93.042",
    transform: "translate(-42.187 -49.459)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16005",
    "data-name": "Path 16005",
    d: "M62.57,69.74a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,69.74Z",
    transform: "translate(-42.426 -48.813)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16006",
    "data-name": "Path 16006",
    d: "M62.57,72.949a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,72.949Z",
    transform: "translate(-42.426 -48.086)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16007",
    "data-name": "Path 16007",
    d: "M62.57,76.17a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,76.17Z",
    transform: "translate(-42.426 -47.357)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16008",
    "data-name": "Path 16008",
    d: "M62.57,79.379a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,79.379Z",
    transform: "translate(-42.426 -46.63)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16009",
    "data-name": "Path 16009",
    d: "M62.57,82.6a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,82.6Z",
    transform: "translate(-42.426 -45.901)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16010",
    "data-name": "Path 16010",
    d: "M62.57,85.822a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.57,85.822Z",
    transform: "translate(-42.426 -45.171)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16011",
    "data-name": "Path 16011",
    d: "M50.892,84.083H69.257V96.275H50.892Z",
    transform: "translate(-45.007 -45.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16012",
    "data-name": "Path 16012",
    d: "M59.2,93.013l-4.244.093-1.219-1.713,3.287-1.559s1,1.08,1.512,1.512,3.04.664,3.04.664S61.391,93.183,59.2,93.013Z",
    transform: "translate(-44.364 -44.137)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16013",
    "data-name": "Path 16013",
    d: "M58.974,92.6l.8,1a1.593,1.593,0,0,0,.8.525l1.543.417a.582.582,0,0,1-.2,1.142s-2.068-.154-2.747-.278a6.459,6.459,0,0,1-4.445-2.7l3.688-1.034Z",
    transform: "translate(-44.139 -43.721)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16014",
    "data-name": "Path 16014",
    d: "M46.917,85.268,54.742,97.29l.494.756,5.556-3.55-.355-.725L54.88,82.49l7.964-9.013L56.5,68.832,47.4,79.156A5,5,0,0,0,46.917,85.268Z",
    transform: "translate(-46.094 -48.892)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16015",
    "data-name": "Path 16015",
    d: "M61.5,58.714v7.824l2.269,1.513,2.5-1.513V58.714Z",
    transform: "translate(-42.606 -51.183)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16016",
    "data-name": "Path 16016",
    d: "M61.513,62.15a4.924,4.924,0,0,0,4.753,1.358V60.992c-.88.015-1.605.077-1.605.077Z",
    transform: "translate(-42.603 -50.667)",
    fill: "#b6662d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16017",
    "data-name": "Path 16017",
    d: "M64.535,64.357a4.784,4.784,0,1,1,4.784-4.784A4.784,4.784,0,0,1,64.535,64.357Z",
    transform: "translate(-43.002 -52.072)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16018",
    "data-name": "Path 16018",
    d: "M68.757,59.591l.432-.972s-.17-.818-.9-3.982C68.309,54.637,65.007,57.863,68.757,59.591Zm-8.473,0-.432-.972s.17-.818.9-3.982C60.747,54.637,64.034,57.863,60.284,59.591Z",
    transform: "translate(-42.979 -52.106)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16019",
    "data-name": "Path 16019",
    d: "M60.16,59.429a1.224,1.224,0,1,1,1.327-1.219A1.277,1.277,0,0,1,60.16,59.429Z",
    transform: "translate(-43.21 -51.573)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16020",
    "data-name": "Path 16020",
    d: "M60.077,57.33a.836.836,0,0,0-.88.8.746.746,0,0,0,.247.556",
    transform: "translate(-43.127 -51.496)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16021",
    "data-name": "Path 16021",
    d: "M67.66,59.429a1.224,1.224,0,1,1,1.327-1.219A1.277,1.277,0,0,1,67.66,59.429Z",
    transform: "translate(-41.511 -51.573)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M67.415,57.33a.836.836,0,0,1,.88.8.746.746,0,0,1-.247.556",
    transform: "translate(-41.267 -51.496)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M67.669,55.909l.463-1.173a14.044,14.044,0,0,0-7.562,0l.91,2.053C61.5,56.789,67.175,57.252,67.669,55.909Z",
    transform: "translate(-42.816 -52.205)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M65.85,64.314l-2.5,2.469,1.713,1.528,1.188-2.948Z",
    transform: "translate(-42.187 -49.915)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16025",
    "data-name": "Path 16025",
    d: "M63.869,66.781l-2.253-2.454-.556,1.049,1.08,3.071Z",
    transform: "translate(-42.705 -49.912)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16026",
    "data-name": "Path 16026",
    d: "M60.653,73.664h-3.8",
    transform: "translate(-43.657 -47.798)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M53.145,92.689l.478.741,5.556-3.549-.355-.725Z",
    transform: "translate(-44.497 -44.291)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16028",
    "data-name": "Path 16028",
    d: "M53.246,80.993l1.945-5.618.216,3.164Z",
    transform: "translate(-44.475 -47.411)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16029",
    "data-name": "Path 16029",
    d: "M67.12,91.824l4.244.093L72.583,90.2,69.3,88.645s-1,1.08-1.512,1.512-3.04.664-3.04.664S64.929,91.994,67.12,91.824Z",
    transform: "translate(-41.871 -44.406)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16030",
    "data-name": "Path 16030",
    d: "M67.343,91.408l-.8,1a1.594,1.594,0,0,1-.8.525l-1.543.417a.582.582,0,0,0,.2,1.142s2.068-.154,2.747-.278a6.459,6.459,0,0,0,4.445-2.7L67.9,90.482Z",
    transform: "translate(-42.094 -43.99)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16031",
    "data-name": "Path 16031",
    d: "M81.048,84.078,73.224,96.1l-.494.756-5.556-3.55.355-.725L73.085,81.3l-7.964-9.013,6.343-4.645L80.57,77.967A5,5,0,0,1,81.048,84.078Z",
    transform: "translate(-41.786 -49.162)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16032",
    "data-name": "Path 16032",
    d: "M72.842,91.5l-.478.741-5.556-3.55.355-.725Z",
    transform: "translate(-41.404 -44.56)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16033",
    "data-name": "Path 16033",
    d: "M72.026,79.8l-1.945-5.618-.216,3.164Z",
    transform: "translate(-40.712 -47.68)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16034",
    "data-name": "Path 16034",
    d: "M68.433,55.266s-2.9,1.96-7.9.756L60.053,57.8l.123-2.886,3.951-1.482L68.31,54.88Z",
    transform: "translate(-42.933 -52.38)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M64.428,60.659a1.481,1.481,0,0,1-1.682-.648",
    transform: "translate(-42.324 -50.89)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.f7233497c6db7951b8b61e6fc9b83dfb.svg";
export { ForwardRef as ReactComponent };